<template>
  <div
    class="push-notification-main-wrapper cbg-white-container input-container theme--light v-card"
  >
    <div>
      <v-tabs v-model="tabs" background-color="transparent" class="border-bottom">
        <v-tab v-for="item in items" :key="item">{{item.tabName}}</v-tab>
        <!-- <v-tab>Sent Messages</v-tab> -->
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <!-- .......... new message ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <newMessages v-if="tabs == 0" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... end new message ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <sentMessages
                v-if="tabs == 1 && permissions.includes('VIEW_SEND_MESSAGES_PUSH_NOTIFICATION')"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... end sent messages ......... -->
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/_systemNotifications.scss";
import { pickSvg } from "@/views/SVG";
const newMessages = () =>
  import("@/views/dashboardNew/systemNotifications/newMessages");
const sentMessages = () =>
  import("@/views/dashboardNew/systemNotifications/sentMessages");
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      tabs: null,
      items: [{ tabName: "New Message" }, { tabName: "Sent Messages" }]
    };
  },

  components: {
    ...pickSvg("filterSVG"),
    newMessages,
    sentMessages
  }
};
</script>